import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { OfbizFormField } from './ofbiz-form-model';
import { ConfigurationService } from '@urbannex/configuration';
// import { CKEditorModule } from 'ng2-ckeditor';


@Component({
  selector: 'ubs-ofbiz-form-field',
  templateUrl: './ofbiz-form-field.component.html',
  styleUrls: ['./ofbiz-form-field.component.scss']
})
export class OfbizFormFieldComponent implements OnInit, OnChanges {
  @Input() formField: OfbizFormField<any>;
  @Input() form: FormGroup;
  @Output() openFieldDialogEvent: EventEmitter<any> = new EventEmitter<any>();
  isHiddenField: boolean = false;
  baseUrl: string;
  // public Editor = ClassicEditor;
  /* public editorConfig = {
    toolbar: [
      [ 'Source' ],
      [ 'Styles', 'Format', 'Font', 'FontSize' ],
      [ 'Bold', 'Italic' ],
      [ 'Undo', 'Redo' ],
      [ 'bulletedList','numberedList'],
      [ 'About' ]
    ]
  } */

  showPassword = true;

  @Output() selectedFile = new EventEmitter<any>();


  constructor(private date: DatePipe, private configServices: ConfigurationService) {
    this.baseUrl = configServices.baseUrl;
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    // Add '${implements OnChanges}' to the class.
    if (changes.formField) {
      console.log('Form Field changed:', this.formField);
      switch (this.formField.controlType) {
        case "hidden":
          this.isHiddenField = true;
          break;
        case "image":
          const parsedUrl = new URL(this.baseUrl);
          const imageBaseUrl = `${parsedUrl.protocol}//${parsedUrl.hostname}${parsedUrl.port ? `:${parsedUrl.port}` : ''}`;
          this.formField.value = imageBaseUrl + this.formField.value
          break;
        case "datetime":
          if (this.formField.value) {
            this.form.controls[this.formField.name].patchValue(this.formField.value);
            // this.formField.value = new Date(this.formField.value);
          }
          break;
        default:
          break;
      }
      console.log(this.formField);
      if (this.formField.controlType == "hidden") {
        this.isHiddenField = true;
      }
      if (this.formField.controlType == "dropdown") {
        // console.log()
      }

    }
  }
  /**
   * 1. Receives data emitted from the LookupFieldComponent containing the value for the field
   * 2. Patch the form control with the value
   * @param data
   */
  setLookupField(data): void {
    this.form.controls[this.formField.name].patchValue(data);
  }
  /**
   * 1. Receives data emitted from the DateFieldComponent containing the value for the field
   * 2. Patch the form control with the incoming value
   * @param data
   */
  setDateField(data): void {
    this.form.controls[this.formField.name].patchValue(data.toISOString().replace("T", " ").replace("Z", ""));
    // console.log(data.toISOString());
  }

  openLookupDialog(data) {
    console.log({ TrackDialog: { component: "OfbizFormFieldComponent", data: data } });
    this.openFieldDialogEvent.emit(data);
  }


  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }

  getInputType() {
    if (this.showPassword) {
      return 'text';
    }
    return 'password';
  }

  get passwordValue() {
    return this.form.get('password').value;
  }

  get passwordControl(): AbstractControl {
    return this.form.get('password');
  }

  get confirmPasswordControl() {
    return this.form.get('confirmPassword');
  }


  get isValid() { return this.form.controls[this.formField.name].valid; }

  get fieldVar() { return this.form.get(this.formField.name); }

  uploadFile(event) {
    console.log("It changed", event);
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      // file = new File([file], file.name);

      // this.form.controls[this.formField.name].patchValue(file);
      this.selectedFile.emit(file);
      // this.form.get('uploadedFile').setValue(file);
    }


  }
  setTextQBEField(e) {
    console.log("Text QBE field setting not implemented yet", e);
  }

  openTextQBEDialog(e) { }

}
